const CompanyLogo = () => {
  return (
    <svg
      viewBox="0 0 1642 452"
    >
      <g className="layer-text">
        <path
          className="st0"
          d="M464.44,282.1c-10.99,0-20.2-0.71-27.63-2.12c-7.43-1.41-13.48-3.82-18.16-7.24
			c-4.68-3.42-8.24-8.06-10.7-13.93c-2.45-5.87-4.12-13.33-5.01-22.39c-0.89-9.06-1.34-19.98-1.34-32.75
			c0-12.77,0.45-23.69,1.34-32.75c0.89-9.06,2.56-16.52,5.01-22.39c2.45-5.87,6.02-10.51,10.7-13.93
			c4.68-3.42,10.73-5.83,18.16-7.24c7.43-1.41,16.63-2.12,27.63-2.12c4.31,0,8.73,0.15,13.26,0.45c4.53,0.3,8.87,0.71,13.04,1.23
			c4.16,0.52,7.72,1.15,10.7,1.89v20.05c-3.71-0.45-7.39-0.85-11.03-1.23c-3.64-0.37-7.17-0.63-10.58-0.78
			c-3.42-0.15-6.39-0.22-8.91-0.22c-8.17,0-14.93,0.3-20.28,0.89c-5.35,0.6-9.62,1.93-12.81,4.01c-3.2,2.08-5.57,5.16-7.13,9.25
			c-1.56,4.09-2.6,9.62-3.12,16.6c-0.52,6.98-0.78,15.75-0.78,26.29c0,10.4,0.26,19.13,0.78,26.18c0.52,7.06,1.56,12.63,3.12,16.71
			c1.56,4.09,3.93,7.17,7.13,9.25c3.19,2.08,7.46,3.42,12.81,4.01c5.35,0.59,12.11,0.89,20.28,0.89c4.9,0,10.28-0.22,16.15-0.67
			c5.87-0.45,10.95-0.96,15.26-1.56v20.5c-3.27,0.6-7.1,1.11-11.48,1.56c-4.38,0.45-8.84,0.81-13.37,1.11
			C472.94,281.95,468.6,282.1,464.44,282.1z"
        />
        <path
          className="st0"
          d="M593.01,282.1c-12.18,0-22.21-0.71-30.08-2.12c-7.88-1.41-14.11-3.82-18.72-7.24
			c-4.61-3.42-7.95-8.09-10.03-14.04c-2.08-5.94-3.42-13.4-4.01-22.39c-0.6-8.99-0.89-19.87-0.89-32.64
			c0-12.77,0.3-23.65,0.89-32.64c0.59-8.99,1.93-16.45,4.01-22.39c2.08-5.94,5.42-10.62,10.03-14.04c4.6-3.42,10.84-5.83,18.72-7.24
			c7.87-1.41,17.9-2.12,30.08-2.12c12.18,0,22.24,0.71,30.19,2.12c7.94,1.41,14.22,3.83,18.83,7.24c4.6,3.42,7.98,8.1,10.14,14.04
			c2.15,5.94,3.53,13.41,4.12,22.39c0.59,8.99,0.89,19.87,0.89,32.64c0,12.78-0.3,23.66-0.89,32.64c-0.6,8.99-1.97,16.45-4.12,22.39
			c-2.16,5.94-5.54,10.62-10.14,14.04c-4.61,3.42-10.88,5.83-18.83,7.24C615.25,281.4,605.18,282.1,593.01,282.1z M593.01,260.71
			c7.43,0,13.55-0.22,18.38-0.67c4.83-0.45,8.61-1.56,11.36-3.34c2.75-1.78,4.79-4.71,6.13-8.8c1.34-4.08,2.19-9.65,2.56-16.71
			c0.37-7.05,0.56-16.23,0.56-27.52c0-11.29-0.19-20.46-0.56-27.52c-0.37-7.05-1.23-12.62-2.56-16.71c-1.34-4.08-3.38-7.02-6.13-8.8
			c-2.75-1.78-6.54-2.9-11.36-3.34c-4.83-0.45-10.96-0.67-18.38-0.67c-7.28,0-13.3,0.22-18.05,0.67c-4.76,0.45-8.54,1.56-11.36,3.34
			c-2.82,1.78-4.87,4.72-6.13,8.8c-1.26,4.09-2.08,9.66-2.45,16.71c-0.37,7.06-0.56,16.23-0.56,27.52c0,11.29,0.18,20.46,0.56,27.52
			c0.37,7.06,1.19,12.63,2.45,16.71c1.26,4.09,3.3,7.02,6.13,8.8c2.82,1.78,6.61,2.9,11.36,3.34
			C579.71,260.49,585.73,260.71,593.01,260.71z"
        />
        <path
          className="st0"
          d="M693.05,280.32v-153.3h25.18v131.24h67.96v22.06H693.05z"
        />
        <path
          className="st0"
          d="M813.15,280.32v-153.3h25.18v131.24h67.96v22.06H813.15z"
        />
        <path
          className="st0"
          d="M933.24,280.32v-153.3h102.05v21.39h-76.87v43.9h66.4v21.39h-66.4v45.23h76.87v21.39H933.24z"
        />
        <path
          className="st0"
          d="M1125.98,282.1c-11,0-20.2-0.71-27.63-2.12c-7.43-1.41-13.48-3.82-18.16-7.24
			c-4.68-3.42-8.25-8.06-10.7-13.93c-2.45-5.87-4.12-13.33-5.01-22.39c-0.89-9.06-1.34-19.98-1.34-32.75
			c0-12.77,0.45-23.69,1.34-32.75c0.89-9.06,2.56-16.52,5.01-22.39c2.45-5.87,6.02-10.51,10.7-13.93
			c4.68-3.42,10.73-5.83,18.16-7.24c7.43-1.41,16.63-2.12,27.63-2.12c4.31,0,8.73,0.15,13.26,0.45c4.53,0.3,8.87,0.71,13.04,1.23
			c4.16,0.52,7.72,1.15,10.7,1.89v20.05c-3.71-0.45-7.39-0.85-11.03-1.23c-3.64-0.37-7.17-0.63-10.58-0.78
			c-3.42-0.15-6.39-0.22-8.91-0.22c-8.17,0-14.93,0.3-20.28,0.89c-5.35,0.6-9.62,1.93-12.81,4.01c-3.2,2.08-5.57,5.16-7.13,9.25
			c-1.56,4.09-2.6,9.62-3.12,16.6c-0.52,6.98-0.78,15.75-0.78,26.29c0,10.4,0.26,19.13,0.78,26.18c0.52,7.06,1.56,12.63,3.12,16.71
			c1.56,4.09,3.93,7.17,7.13,9.25c3.19,2.08,7.46,3.42,12.81,4.01c5.35,0.59,12.11,0.89,20.28,0.89c4.9,0,10.29-0.22,16.15-0.67
			c5.87-0.45,10.95-0.96,15.26-1.56v20.5c-3.27,0.6-7.1,1.11-11.48,1.56c-4.38,0.45-8.84,0.81-13.37,1.11
			C1134.48,281.95,1130.14,282.1,1125.98,282.1z"
        />
        <path
          className="st0"
          d="M1227.58,280.32V149.08h-46.57v-22.06h118.09v22.06h-46.35v131.24H1227.58z"
        />
        <path
          className="st0"
          d="M1383.78,282.1c-12.18,0-22.21-0.71-30.08-2.12c-7.88-1.41-14.11-3.82-18.72-7.24
			c-4.61-3.42-7.95-8.09-10.03-14.04c-2.08-5.94-3.42-13.4-4.01-22.39c-0.6-8.99-0.89-19.87-0.89-32.64
			c0-12.77,0.29-23.65,0.89-32.64c0.59-8.99,1.93-16.45,4.01-22.39c2.08-5.94,5.42-10.62,10.03-14.04
			c4.6-3.42,10.84-5.83,18.72-7.24c7.87-1.41,17.9-2.12,30.08-2.12c12.18,0,22.24,0.71,30.19,2.12c7.95,1.41,14.22,3.83,18.83,7.24
			c4.6,3.42,7.98,8.1,10.14,14.04c2.15,5.94,3.53,13.41,4.12,22.39c0.59,8.99,0.89,19.87,0.89,32.64c0,12.78-0.3,23.66-0.89,32.64
			c-0.59,8.99-1.97,16.45-4.12,22.39c-2.16,5.94-5.54,10.62-10.14,14.04c-4.61,3.42-10.88,5.83-18.83,7.24
			C1406.02,281.4,1395.96,282.1,1383.78,282.1z M1383.78,260.71c7.43,0,13.55-0.22,18.38-0.67c4.83-0.45,8.61-1.56,11.36-3.34
			c2.75-1.78,4.79-4.71,6.13-8.8c1.34-4.08,2.19-9.65,2.56-16.71c0.37-7.05,0.56-16.23,0.56-27.52c0-11.29-0.19-20.46-0.56-27.52
			c-0.37-7.05-1.22-12.62-2.56-16.71c-1.34-4.08-3.38-7.02-6.13-8.8c-2.75-1.78-6.54-2.9-11.36-3.34
			c-4.83-0.45-10.96-0.67-18.38-0.67c-7.28,0-13.3,0.22-18.05,0.67c-4.76,0.45-8.54,1.56-11.36,3.34c-2.82,1.78-4.87,4.72-6.13,8.8
			c-1.26,4.09-2.08,9.66-2.45,16.71c-0.37,7.06-0.56,16.23-0.56,27.52c0,11.29,0.19,20.46,0.56,27.52
			c0.37,7.06,1.19,12.63,2.45,16.71c1.26,4.09,3.3,7.02,6.13,8.8c2.82,1.78,6.61,2.9,11.36,3.34
			C1370.48,260.49,1376.5,260.71,1383.78,260.71z"
        />
        <path
          className="st0"
          d="M1483.82,280.32v-153.3h71.53c9.65,0,17.45,1.11,23.4,3.34c5.94,2.23,10.4,5.46,13.37,9.69
			c2.97,4.23,4.97,9.29,6.02,15.15c1.04,5.87,1.56,12.29,1.56,19.27c0,5.05-0.48,10.58-1.45,16.6c-0.97,6.02-3.05,11.51-6.24,16.49
			c-3.2,4.98-8.21,8.58-15.04,10.81l25.18,61.94h-26.74l-24.51-62.61l6.46,3.34c-1.04,0.45-2.27,0.71-3.68,0.78
			c-1.41,0.08-3.08,0.11-5.01,0.11H1509v58.38H1483.82z M1509,200.55h35.65c6.98,0,12.48-0.48,16.49-1.45
			c4.01-0.96,6.98-2.49,8.91-4.57c1.93-2.08,3.15-4.75,3.68-8.02c0.52-3.27,0.78-7.28,0.78-12.03c0-4.9-0.26-9.02-0.78-12.37
			c-0.52-3.34-1.67-6.02-3.45-8.02c-1.78-2.01-4.64-3.45-8.58-4.34c-3.94-0.89-9.32-1.34-16.15-1.34H1509V200.55z"
        />
        <g>
          <path
            className="st0"
            d="M1242.83,419.55v-93.38h15.34v79.94h41.4v13.44H1242.83z"
          />
          <path
            className="st0"
            d="M1351.68,420.64c-7.42,0-13.53-0.43-18.32-1.29c-4.8-0.86-8.6-2.33-11.4-4.41c-2.8-2.08-4.84-4.93-6.11-8.55
			c-1.27-3.62-2.08-8.17-2.44-13.64c-0.36-5.47-0.54-12.1-0.54-19.88c0-7.78,0.18-14.41,0.54-19.88c0.36-5.47,1.18-10.02,2.44-13.64
			c1.27-3.62,3.3-6.47,6.11-8.55c2.8-2.08,6.6-3.55,11.4-4.41c4.79-0.86,10.9-1.29,18.32-1.29c7.42,0,13.55,0.43,18.39,1.29
			c4.84,0.86,8.66,2.33,11.47,4.41c2.8,2.08,4.86,4.93,6.18,8.55c1.31,3.62,2.15,8.17,2.51,13.64c0.36,5.48,0.54,12.1,0.54,19.88
			c0,7.78-0.18,14.41-0.54,19.88c-0.36,5.48-1.2,10.02-2.51,13.64c-1.31,3.62-3.37,6.47-6.18,8.55c-2.81,2.08-6.63,3.55-11.47,4.41
			C1365.23,420.21,1359.1,420.64,1351.68,420.64z M1351.68,407.61c4.52,0,8.25-0.14,11.2-0.41c2.94-0.27,5.25-0.95,6.92-2.04
			c1.67-1.09,2.92-2.87,3.73-5.36c0.81-2.49,1.33-5.88,1.56-10.18c0.22-4.3,0.34-9.88,0.34-16.76c0-6.88-0.11-12.46-0.34-16.76
			c-0.23-4.3-0.75-7.69-1.56-10.18c-0.81-2.49-2.06-4.28-3.73-5.36c-1.67-1.09-3.98-1.76-6.92-2.04c-2.94-0.27-6.67-0.41-11.2-0.41
			c-4.44,0-8.1,0.14-10.99,0.41c-2.9,0.27-5.2,0.95-6.92,2.04c-1.72,1.09-2.96,2.87-3.73,5.36c-0.77,2.49-1.27,5.88-1.49,10.18
			c-0.23,4.3-0.34,9.89-0.34,16.76c0,6.88,0.11,12.47,0.34,16.76c0.23,4.3,0.72,7.69,1.49,10.18c0.77,2.49,2.01,4.28,3.73,5.36
			c1.72,1.09,4.03,1.76,6.92,2.04C1343.58,407.47,1347.25,407.61,1351.68,407.61z"
          />
          <path
            className="st0"
            d="M1449.81,420.64c-6.7,0-12.37-0.43-17.03-1.29c-4.66-0.86-8.53-2.33-11.6-4.41
			c-3.08-2.08-5.45-4.93-7.12-8.55c-1.68-3.62-2.85-8.17-3.53-13.64c-0.68-5.47-1.02-12.1-1.02-19.88c0-7.78,0.34-14.41,1.02-19.88
			c0.68-5.47,1.88-10.02,3.6-13.64c1.72-3.62,4.12-6.47,7.19-8.55c3.08-2.08,6.94-3.55,11.6-4.41c4.66-0.86,10.29-1.29,16.9-1.29
			c2.99,0,6.26,0.14,9.84,0.41c3.57,0.27,7.13,0.61,10.65,1.02c3.53,0.41,6.74,0.88,9.64,1.43v12.21c-3.08-0.45-6.11-0.81-9.09-1.09
			c-2.99-0.27-5.72-0.5-8.21-0.68c-2.49-0.18-4.55-0.27-6.18-0.27c-5.43,0-10,0.11-13.71,0.34c-3.71,0.23-6.74,0.88-9.09,1.97
			c-2.35,1.09-4.16,2.87-5.43,5.36c-1.27,2.49-2.15,5.9-2.65,10.25c-0.5,4.34-0.75,9.95-0.75,16.83c0,6.06,0.16,11.15,0.47,15.27
			c0.32,4.12,1,7.51,2.04,10.18c1.04,2.67,2.49,4.68,4.34,6.04c1.85,1.36,4.3,2.31,7.33,2.85c3.03,0.54,6.76,0.81,11.2,0.81
			c1.72,0,3.55-0.04,5.5-0.14c1.94-0.09,3.78-0.2,5.5-0.34c1.72-0.14,3.17-0.29,4.34-0.47V380.6h-18.32v-12.76h33.12v49.95
			c-3.08,0.54-6.45,1.02-10.11,1.43c-3.67,0.41-7.26,0.75-10.79,1.02C1455.92,420.5,1452.7,420.64,1449.81,420.64z"
          />
          <path
            className="st0"
            d="M1503.83,419.55v-93.38h15.34v93.38H1503.83z"
          />
          <path
            className="st0"
            d="M1579.15,420.64c-6.7,0-12.31-0.43-16.83-1.29c-4.53-0.86-8.21-2.33-11.06-4.41
			c-2.85-2.08-5.02-4.91-6.51-8.48c-1.49-3.57-2.51-8.12-3.05-13.64c-0.54-5.52-0.81-12.17-0.81-19.95c0-7.78,0.27-14.43,0.81-19.95
			c0.54-5.52,1.56-10.06,3.05-13.64c1.49-3.57,3.66-6.4,6.51-8.48c2.85-2.08,6.54-3.55,11.06-4.41c4.52-0.86,10.13-1.29,16.83-1.29
			c2.62,0,5.31,0.09,8.08,0.27c2.76,0.18,5.41,0.43,7.94,0.75c2.53,0.32,4.7,0.7,6.51,1.15v12.21c-2.26-0.27-4.5-0.52-6.72-0.75
			c-2.22-0.23-4.37-0.38-6.45-0.48c-2.08-0.09-3.89-0.14-5.43-0.14c-4.98,0-9.09,0.18-12.35,0.54c-3.26,0.36-5.86,1.18-7.8,2.44
			c-1.95,1.27-3.39,3.14-4.34,5.63c-0.95,2.49-1.58,5.86-1.9,10.11c-0.32,4.25-0.47,9.59-0.47,16.01c0,6.33,0.16,11.65,0.47,15.95
			c0.32,4.3,0.95,7.69,1.9,10.18c0.95,2.49,2.4,4.37,4.34,5.63c1.95,1.27,4.55,2.08,7.8,2.44c3.26,0.36,7.37,0.54,12.35,0.54
			c2.99,0,6.26-0.14,9.84-0.41c3.57-0.27,6.67-0.59,9.3-0.95v12.49c-1.99,0.36-4.32,0.68-6.99,0.95c-2.67,0.27-5.38,0.5-8.14,0.68
			C1584.33,420.54,1581.68,420.64,1579.15,420.64z"
          />
        </g>
      </g>
      <path
        className="layer-icon st1"
        d="M205.68,125.96h-28.86v60.95c0,2.29-1.86,4.14-4.14,4.14h-60.95v28.86h60.95c2.29,0,4.14,1.86,4.14,4.14V285
	h28.86v-60.95c0-2.29,1.86-4.14,4.14-4.14h60.95v-28.86h-60.95c-2.29,0-4.14-1.86-4.14-4.14L205.68,125.96L205.68,125.96z
	 M172.68,117.67h37.15c2.29,0,4.14,1.86,4.14,4.14v60.95h60.95c2.29,0,4.14,1.86,4.14,4.14v37.15c0,2.29-1.86,4.14-4.14,4.14h-60.95
	v60.94c0,2.29-1.86,4.14-4.14,4.14h-37.15c-2.29,0-4.14-1.86-4.14-4.14v-60.95h-60.95c-2.29,0-4.14-1.86-4.14-4.14V186.9
	c0-2.29,1.86-4.14,4.14-4.14h60.95v-60.95C168.53,119.53,170.39,117.67,172.68,117.67L172.68,117.67z M341.06,177.15
	c7.81,7.81,11.71,18.07,11.71,28.33c0,10.26-3.9,20.52-11.71,28.33L219.57,355.29c-7.81,7.81-18.07,11.71-28.33,11.71
	c-10.26,0-20.52-3.9-28.33-11.71L41.44,233.81c-7.81-7.81-11.71-18.07-11.71-28.33c0-10.26,3.9-20.52,11.71-28.33L162.92,55.67
	c7.81-7.81,18.07-11.71,28.33-11.71c10.26,0,20.52,3.9,28.33,11.71L341.06,177.15L341.06,177.15z M191.25,56.38
	c7.08,0,14.16,2.69,19.54,8.08l121.48,121.48c5.38,5.38,8.07,12.46,8.07,19.54s-2.69,14.16-8.07,19.54L210.79,346.5
	c-5.38,5.38-12.46,8.08-19.54,8.08s-14.16-2.7-19.54-8.08L50.22,225.02c-5.38-5.38-8.08-12.46-8.08-19.54s2.69-14.16,8.08-19.54
	L171.71,64.46C177.09,59.07,184.17,56.38,191.25,56.38L191.25,56.38z M204.93,70.31l121.48,121.48c3.77,3.77,5.65,8.73,5.65,13.68
	s-1.88,9.92-5.65,13.68L204.93,340.65c-3.77,3.77-8.73,5.65-13.68,5.65s-9.92-1.88-13.68-5.65L56.08,219.16
	c-3.77-3.77-5.65-8.73-5.65-13.68s1.88-9.92,5.65-13.68L177.56,70.31c3.77-3.77,8.73-5.65,13.68-5.65S201.17,66.54,204.93,70.31z"
      />
      <path
        className="st2"
        d="M205.68,125.96h-28.86v60.95c0,2.29-1.86,4.14-4.14,4.14h-60.95v28.86h60.95c2.29,0,4.14,1.86,4.14,4.14V285
	h28.86v-60.95c0-2.29,1.86-4.14,4.14-4.14h60.95v-28.86h-60.95c-2.29,0-4.14-1.86-4.14-4.14L205.68,125.96L205.68,125.96z"
      />
    </svg>
  )
}
export default CompanyLogo
